<div class="dashboard-container">
	<div *ngFor="let card of cards;" class="card-wrapper">
	  <vias-info-card [card]="card"></vias-info-card>
	</div>
  </div>